import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

import Alert from '../../../../shared/components/Alert';

class DistributionModals extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      postValue: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
         }),
      ]),
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      handleSubmit: () => {
         console.log('submitted');
      },
      postValue: {},
      errorMsg: '',
   };

   constructor(props) {
      super(props);
      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
   }

   componentDidMount() {
   this.isLoading = true;
   }

   componentWillUnmount() {
   this.isLoading = false;
   }

    toggle() {
       this.setState(prevState => ({ modal: !prevState.modal }));
    }

    render() {
        const {
           toggle, modal, postValue, handleChange, handleSubmit, errorMsg,
        } = this.props;

        return (
            <div>
               <Modal
                  isOpen={modal}
                  className="modal-dialog--primary modal-dialog--header"
               >

                  <div>
                     <div className={`modal__header ${postValue.status === 1 ? 'bg-green' : 'bg-red'}`}>
                        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                        <h4 className="bold-text  modal__title">Confirmation</h4>
                     </div>
                     <form onSubmit={handleSubmit} id="stocks_form">
                        <div className="modal__body p-t-10">
                        { errorMsg && (
                           <div className="notif_msg">
                              <Alert color="danger" className="alert--colored m-b-10">
                                 <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                              </Alert>
                           </div>
                           )
                        }
                        <div className="form form--vertical m-t-10">

                           {postValue.status === 1 ? (
                              <div className="form__form-group">
                                 <span className="form__form-group-label">Actual Quantity <b className="text-danger">*</b></span>
                                 <div className="form__form-group-field">
                                    <input type="text" name="actualQuantity" value={postValue.actualQuantity ? postValue.actualQuantity : ''} placeholder="Actual Quantity" onChange={handleChange} />
                                 </div>
                              </div>
                           ) : '' }


                           <div className="form__form-group">
                              {postValue.status === 1 ? (
                                 <span className="form__form-group-label">Note</span>
                              ) : (
                                 <span className="form__form-group-label">Reason <b className="text-danger m-l-5">*</b></span>
                              )}

                              <div className="form__form-group-field">
                                 <textarea name="note" value={postValue.note ? postValue.note : ''} className="no-resize mh-120" onChange={handleChange} />
                              </div>
                           </div>
                        </div>
                        </div>
                        <ButtonToolbar className="modal__footer">
                           <Button color="primary">Submit</Button>
                           <Button onClick={toggle}>Cancel</Button>
                        </ButtonToolbar>
                     </form>
                  </div>

               </Modal>
            </div>
         );
    }
}

export default reduxForm({
    form: 'commissaryStockConfirmationForm',
})(withTranslation('common')(DistributionModals));
